import styles from '../../styles/modules/components/covered-not-covered.module.scss';
import Section from '../../components/common/Section';

export default function CoveredNotCovered(props:any){
    return (
        <Section className={`${styles.gray_bg}`}>
            <div className={`${styles.selection} ${styles.no__background}`}>
                <div className={`container ${styles.card_holder}`}>
                    <div className="row">
                        <div className="col-12 col-md-12 col-lg-6">
                        <div className={` ${styles.contains}`}>
                        <div className={` ${styles.card} ${styles.vertical__scroll}`}>
                            <h2 className={`${styles._text} `}>What is Covered</h2>
                            <ul>
                                {props.coveredText && props.coveredText.map((item,key)=>{
                                    return <li key={`covered-${key}`}>{item}</li>
                                })}
                            </ul>
                        </div>
                        </div>
                    </div>
                        <div className="col-12 col-md-12 col-lg-6">
                        <div className={` ${styles.contains}`}>
                            <div className={` ${styles.card} ${styles.vertical__scroll}`}>
                            <h2 className={`${styles._text} `}>What is Not Covered</h2>
                            <ul>
                                {props.notCoveredText && props.notCoveredText.map((item,key)=>{
                                    return <li key={`not-covered-${key}`} className={`${styles.cross__mark}`}>{item}</li>
                                })}
                            </ul>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </Section>
    )
}